/* The Kit (bundles), sections/atlas-home-kit-bundle.liquid. Built from atlas-home-kit.js.
   Each look is one Shopify Bundles product. Sizes are picked on the piece cards (a card's data-k is the bundle option
   it sets; -1 is a fixed piece). The button adds the bundle variant matching the chosen sizes. Looks auto-advance with
   a progress bar; any tap on a size, hotspot or card (or a swipe through the cards) pauses that for a few seconds.
   Chosen sizes are kept per look, so switching never loses them. */
(function () {
  var money = function (cents) { return window.Atlas && window.Atlas.money ? window.Atlas.money(cents) : (cents / 100).toFixed(0); };

  function init(root) {
    if (root.__kitb) root.__kitb();
    var photos = [].slice.call(root.querySelectorAll('.kitb__photo'));
    var spotSets = [].slice.call(root.querySelectorAll('.kitb__spots'));
    var groups = [].slice.call(root.querySelectorAll('.kitb__group'));
    var bars = [].slice.call(root.querySelectorAll('[data-bar]'));
    var fills = bars.map(function (b) { return b.querySelector('.kitb__fill'); });
    var cta = root.querySelector('[data-cta]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var ctaPrice = root.querySelector('[data-cta-price]');
    var ctaWas = root.querySelector('[data-cta-was]');
    var errEl = root.querySelector('[data-err]');
    var stage = root.querySelector('[data-stage]');
    var n = photos.length;
    var ms = parseInt(root.getAttribute('data-ms'), 10) || 6000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var HOLD = 8000;
    var li = 0, paused = false, holdUntil = 0, sx = null, sy = null, raf = 0, last = 0, elapsed = 0, busy = false, doneTimer = 0;

    /* Per look: bundle data and the chosen size per option */
    var looks = groups.map(function (g) {
      var data = { variants: [], available: false, price: 0, was: 0 };
      var node = g.querySelector('[data-kitb-json]');
      try { data = JSON.parse(node.textContent); } catch (e) {}
      var sel = {};
      var opts = 0;
      g.querySelectorAll('[data-card]').forEach(function (c) {
        var k = parseInt(c.getAttribute('data-k'), 10);
        if (k < 0) return;
        opts = Math.max(opts, k + 1);
        var sizes = c.querySelectorAll('[data-size]');
        if (sizes.length === 1) sel[k] = sizes[0].getAttribute('data-size');
      });
      return { el: g, data: data, sel: sel, opts: opts };
    });

    /* a bundle combination the cart refused as sold out greys out (atlas-runtime.js) */
    function onSold(e) {
      var ids = e.detail.ids, hit = false;
      looks.forEach(function (L) {
        (L.data.variants || []).forEach(function (v) { if (v.available && ids.indexOf(v.id) > -1) { v.available = false; hit = true; } });
        L.data.available = (L.data.variants || []).some(function (v) { return v.available; });
      });
      if (hit) paint();
    }
    document.addEventListener('atlas:soldout', onSold);

    /* a look's video plays only while its look is showing and the section is on screen */
    var onScreen = true;
    function syncVids() {
      photos.forEach(function (p, j) {
        var v = p.querySelector('video');
        if (!v) return;
        v.muted = true;
        if (j === li && onScreen) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else v.pause();
      });
    }
    var vio = null;
    if (root.querySelector('.kitb__photo video') && 'IntersectionObserver' in window) {
      vio = new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; syncVids(); }, { threshold: 0.15 });
      vio.observe(stage || root);
    }

    function hold() { holdUntil = performance.now() + HOLD; }
    function cur() { return looks[li]; }
    function cardsOf(i) { return looks[i] ? [].slice.call(looks[i].el.querySelectorAll('[data-card]')) : []; }

    function variantFor(L) {
      return L.data.variants.find(function (v) {
        return v.options.length === L.opts && v.options.every(function (o, i) { return L.sel[i] === o; });
      });
    }
    /* A size stays pickable when it still makes an available bundle with the sizes already chosen */
    function sizeOk(L, k, z) {
      return L.data.variants.some(function (v) {
        return v.available && v.options[k] === z && v.options.every(function (o, i) { return i === k || !L.sel[i] || L.sel[i] === o; });
      });
    }

    function pick(num) {
      var set = spotSets[li];
      if (set) set.querySelectorAll('[data-spot]').forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-spot') === String(num)); });
      cardsOf(li).forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-card') === String(num)); });
    }
    function reveal(card) {
      var row = card.parentElement;
      if (!row) return;
      var left = card.offsetLeft - row.offsetLeft;
      if (left < row.scrollLeft || left + card.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = left;
    }

    function paint() {
      var L = cur();
      if (!L) return;
      cardsOf(li).forEach(function (c) {
        var k = parseInt(c.getAttribute('data-k'), 10);
        if (k < 0) return;
        c.classList.toggle('is-set', !!L.sel[k]);
        c.querySelectorAll('[data-size]').forEach(function (b) {
          var z = b.getAttribute('data-size');
          var on = L.sel[k] === z;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.disabled = !sizeOk(L, k, z);
        });
        var num = c.getAttribute('data-card');
        var spot = spotSets[li] && spotSets[li].querySelector('[data-spot="' + num + '"]');
        if (spot) spot.classList.toggle('is-set', !!L.sel[k]);
      });
      cardsOf(li).forEach(function (c) {
        if (parseInt(c.getAttribute('data-k'), 10) >= 0) return;
        var spot = spotSets[li] && spotSets[li].querySelector('[data-spot="' + c.getAttribute('data-card') + '"]');
        if (spot) spot.classList.add('is-set');
      });
      if (!cta || busy || doneTimer) return;
      var left = 0;
      for (var k = 0; k < L.opts; k++) if (!L.sel[k]) left++;
      var v = left === 0 ? variantFor(L) : null;
      var label;
      cta.classList.remove('is-wait');
      if (!L.data.available) { label = cta.getAttribute('data-sold'); cta.classList.add('is-wait'); }
      else if (left === 0 && !(v && v.available)) { label = cta.getAttribute('data-unavailable'); cta.classList.add('is-wait'); }
      else if (left === 0) label = cta.getAttribute('data-add');
      else if (left === L.opts) label = cta.getAttribute('data-select');
      else if (left === 1) label = cta.getAttribute('data-one') || cta.getAttribute('data-more').replace('[n]', left);
      else label = cta.getAttribute('data-more').replace('[n]', left);
      ctaLabel.textContent = label;
      var price = v ? v.price : L.data.price;
      var was = v ? v.was : L.data.was;
      ctaPrice.textContent = money(price);
      ctaWas.textContent = was > price ? money(was) : '';
    }

    function paintBars() {
      fills.forEach(function (f, j) {
        if (!f) return;
        var p = j < li ? 1 : j > li ? 0 : (reduce ? 1 : Math.min(elapsed / ms, 1));
        f.style.transform = 'scaleX(' + p + ')';
      });
    }
    function tick(t) {
      if (!last) last = t;
      var dt = t - last; last = t;
      if (!paused && !document.hidden && t > holdUntil) elapsed += Math.min(dt, 100);
      if (elapsed >= ms) { go(li + 1); } else { paintBars(); }
      raf = requestAnimationFrame(tick);
    }

    function go(i) {
      li = ((i % n) + n) % n;
      elapsed = 0;
      photos.forEach(function (p, j) { p.classList.toggle('is-active', j === li); });
      syncVids();
      spotSets.forEach(function (s, j) { s.hidden = j !== li; });
      groups.forEach(function (g, j) { g.hidden = j !== li; });
      if (errEl) errEl.hidden = true;
      var first = cardsOf(li)[0];
      if (first) pick(first.getAttribute('data-card'));
      paint();
      paintBars();
    }

    function showErr(text) {
      if (!errEl) return;
      errEl.textContent = text || 'Sorry, this couldn\'t be added to your cart. Please try again.';
      errEl.hidden = false;
    }

    function addKit() {
      var L = cur();
      if (!L || busy) return;
      if (errEl) errEl.hidden = true;
      /* sizes missing: point at the first piece that still needs one */
      for (var k = 0; k < L.opts; k++) {
        if (!L.sel[k]) {
          var need = L.el.querySelector('[data-card][data-k="' + k + '"]');
          if (need) {
            pick(need.getAttribute('data-card'));
            reveal(need);
            need.classList.remove('is-need');
            void need.offsetWidth;
            need.classList.add('is-need');
          }
          return;
        }
      }
      var v = variantFor(L);
      if (!v || !v.available || !window.Atlas || !window.Atlas.cart) return;
      busy = true;
      cta.classList.add('is-loading');
      window.Atlas.cart.add([{ id: v.id, quantity: 1 }], { open: true })
        .then(function () {
          busy = false;
          cta.classList.remove('is-loading');
          ctaLabel.textContent = cta.getAttribute('data-done');
          ctaPrice.textContent = '✓';
          ctaWas.textContent = '';
          doneTimer = setTimeout(function () { doneTimer = 0; paint(); }, 2500);
        })
        .catch(function (err) {
          busy = false;
          cta.classList.remove('is-loading');
          showErr(err && err.description);
          paint();
        });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var size = t.closest('[data-size]');
      if (size && !size.disabled) {
        var card = size.closest('[data-card]');
        var k = parseInt(card.getAttribute('data-k'), 10);
        var L = cur();
        var z = size.getAttribute('data-size');
        L.sel[k] = L.sel[k] === z && size.parentElement.children.length > 1 ? undefined : z;
        hold();
        if (errEl) errEl.hidden = true;
        pick(card.getAttribute('data-card'));
        paint();
        paintBars();
        return;
      }
      var spot = t.closest('[data-spot]');
      if (spot) {
        hold();
        var num = spot.getAttribute('data-spot');
        pick(num);
        var c = cur() && cur().el.querySelector('[data-card="' + num + '"]');
        if (c) reveal(c);
        return;
      }
      var bar = t.closest('[data-bar]');
      if (bar) { go(parseInt(bar.getAttribute('data-bar'), 10)); return; }
      if (t.closest('[data-prev]')) { go(li - 1); return; }
      if (t.closest('[data-next]')) { go(li + 1); return; }
      if (t.closest('[data-cta]')) { addKit(); return; }
      var cardEl = t.closest('[data-card]');
      if (cardEl && !t.closest('a')) { hold(); pick(cardEl.getAttribute('data-card')); }
    });
    root.addEventListener('mouseover', function (e) {
      var el = e.target.closest('[data-spot],[data-card]');
      if (!el) return;
      pick(el.getAttribute('data-spot') || el.getAttribute('data-card'));
    });

    function onEnter() { if (window.innerWidth >= 1040) paused = true; }
    function onLeave() { paused = false; }
    root.addEventListener('mouseenter', onEnter);
    root.addEventListener('mouseleave', onLeave);
    function onTs(e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
    function onTe(e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (n > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(li + (dx < 0 ? 1 : -1));
    }
    if (stage) { stage.addEventListener('touchstart', onTs, { passive: true }); stage.addEventListener('touchend', onTe); }
    /* swiping through the piece cards counts as using the look */
    root.querySelectorAll('[data-cards]').forEach(function (row) { row.addEventListener('scroll', hold, { passive: true }); });

    go(0);
    if (!reduce && n > 1) raf = requestAnimationFrame(tick);
    root.__kitb = function () {
      cancelAnimationFrame(raf);
      clearTimeout(doneTimer);
      root.removeEventListener('mouseenter', onEnter);
      root.removeEventListener('mouseleave', onLeave);
      document.removeEventListener('atlas:soldout', onSold);
      if (vio) vio.disconnect();
    };
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-kitb]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
